export class MasterConstants {
  public static readonly ENVIRONMENT = 'environment';
  public static readonly LOG_OFF_TIME = 'LogOffTime';
  public static readonly CUSTOMER_SERVICE_EMAIL = 'CUSTOMER_SERVICE_EMAIL';
  // Constant values for masters
  public static readonly PRODUCT_MASTER_LIST = 'BrandMasters';
  public static readonly MARKETING_BRAND_MASTER_LIST = 'marketingBrandMasters';
  public static readonly ALL_MARKETING_BRAND_LIST = 'allMarketingBrand';
  public static readonly SEED_SIZE_MASTER_LIST = 'seedSizeMasters';
  public static readonly ALL_SEED_SIZE_LIST = 'allSeedSize';
  public static readonly PACKAGE_SIZE_MASTER_LIST = 'packageSizeMasters';
  public static readonly ALL_PACKAGE_SIZE_LIST = 'allPackageSize';
  public static readonly CPP_PACKAGE_SIZE_LIST = 'cppPackageSize';
  public static readonly TREATMENT_MASTER_LIST = 'treatmentMasters';
  public static readonly ALL_TREATMENT_LIST = 'allTreatment';
  public static readonly TECHNOLOGY_MASTER_LIST = 'technologyMasters';
  public static readonly MATURITY_MASTER_LIST = 'maturityMasters';
  public static readonly MATURITY_LIST = 'maturityList';
  public static readonly PRODUCT_LINE_MASTER_LIST = 'productLineMasters';
  public static readonly ACTIVE_CROP_YEAR = 'activeCropYear';
  public static readonly PRODUCT_LINE_MASTER_CPP_LIST = 'productLineMastersCPP';
  public static readonly CROP_YEAR_START_DATE = 'cropYearStartDate';
  public static readonly CROP_YEAR_END_DATE = 'cropYearEndDate';
  

  public static readonly HEADER_CROP_YEAR = 'headerCropYear';
  public static readonly HEADER_COMPANY_CODE = 'headerCompanyCode';
  public static readonly EVOLVE_ACCESS = 'evolveAccess';
  public static readonly IS_LOGOUT = 'isLogOut';
  public static readonly IS_RELOAD = 'isReload';
  public static readonly APP_VERSION = 'AppVersion';
  public static BILLING_ADDRESS_TYPE = { 'X': 'X', 'S': 'S' };
  public static readonly REPORT_PACKAGE_SIZE_MASTER_LIST = 'reportpackageSizeMasters';
  public static readonly ORDER_TAB_INDEX = 'orderTabIndex';

  public static readonly PRODUCT_CATEGORY_MASTER_LIST = 'productCategoryMasters';
  public static readonly PRODUCT_SEGMENT_MASTER_LIST = 'productSegmentMasters';
  // public static readonly HYBRID_VARIETY_MASTER_LIST = "hybridVarietyMasters";
  public static readonly FREIGHT_HANDLING_CODE_MASTER_LIST = 'freighthandlingCodeMasters';
  public static readonly FREIGHT_INSTRUCTION_MASTER_LIST = 'freightInstructionMasters';
  public static readonly BRANCH_PLANT_MASTER_LIST = 'branchPlantMasters';
  public static readonly PALLET_LINES_MASTER_LIST = 'palletLinesMasters';
  public static readonly VERSION_CONTROL_MASTER_LIST = 'versionControlMasters';
  public static readonly ORDER_CHANGE_CODE_TYPE_MASTER_LIST = 'orderChangeCodeTypeMasters';
  public static readonly SEED_TERMS_AND_CONDITION_DOWNLOADED = 'seedtermsandconditionDownloaded';
  public static readonly CPP_TERMS_AND_CONDITION_DOWNLOADED = 'cpptermsandconditionDownloaded';
  // public static readonly ITEM_NUMBER_MASTER_LIST = "itemNumberMasters";
  public static readonly SEED_RETURN_ITEM_NUMBER_MASTER_LIST = 'seedreturnitemNumberMasters';
  public static readonly CPP_RETURN_ITEM_NUMBER_MASTER_LIST = 'cppreturnitemNumberMasters';
  public static readonly CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST = 'containerreturnitemNumberMasters';
  public static readonly CPP_ERROR_CONFIG_MESSAGE = 'cpperrorconfigmessage';
  public static readonly WF_Sales_GenericLevel = 'wfsSalesGenericLevel';
  public static readonly WF_Impl_SplList_Display = 'IMPLEMENTATIONSPECIALIST';
  public static readonly WF_Impl_SplList_BU_Display = 'IMPLEMENTATIONSPECIALISTBU';

  public static readonly CUTCANCEL_CANCELLATION_MESSAGE = 'If you are canceling or reducing this seed item, and it affects your dealer order, it could result in an inventory management fee that will be assessed on a future invoice.  If you have questions, please contact WinField United Customer Service at 1-855-494-6343.';
  public static readonly CUTCANCEL_PACKAGE_SIZE_MESSAGE = 'If you are changing the package size on this seed item, and it affects your dealer order, it could result in an rebagging fee that will be assessed on a future invoice.  If you have questions, please contact WinField United Customer Service at 1-855-494-6343.';
  public static readonly OTI_BACK_TO_ORDER = 'otiBackToOrder';
  public static readonly OTI_FILTER_DATA = 'otifilterData';
  public static readonly SEED_EA_ACCESS = 'seedeaaccess';

  public static readonly OTI_CUSTOMERPO = 'otiCustomerPO';
  public static readonly OTI_ACCOUNTNUMBER = 'otiAccountNumber';
  public static readonly OTI_SALESORDERNUMBER = 'otiSalesOrderNumber';

  public static readonly MESSAGE_GROWER_LICENSE_PAGE_WIP = 'GROWER_LICENSE_PAGE_WIP';
  public static readonly MESSAGE_GROWER_LICENSE_MISSING = 'GROWER_LICENSE_MISSING_MSG';
  public static readonly MESSAGE_GROWER_LICENSE_MISSING_MOBILE = 'GROWER_LICENSE_MISSING_MOBILE_MSG';
  public static readonly AGCELERATE_REGISTRATION_URL = 'https://www.agcelerate.com';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_GP = 'GROWER_SEARCH_NOT_FOUND_GP';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_GOT = 'GROWER_SEARCH_NOT_FOUND_GOT';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_SRE = 'GROWER_SEARCH_NOT_FOUND_SRE';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_SCL = 'GROWER_SEARCH_NOT_FOUND_SCL';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_SAME_DEALER_TFR = 'GROWER_SEARCH_NOT_FOUND_SAME_DEALER_TFR';
  public static readonly MESSAGE_GROWER_SEARCH_NOT_FOUND_OTHER_DEALER_TFR = 'GROWER_SEARCH_NOT_FOUND_OTHER_DEALER_TFR';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_GP = 'REQUEST_NEW_GROWER_GP';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_GOT = 'REQUEST_NEW_GROWER_GOT';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_SRE = 'REQUEST_NEW_GROWER_SRE';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_SCL = 'REQUEST_NEW_GROWER_SCL';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_SAME_DEALER_TFR = 'REQUEST_NEW_GROWER_SAME_DEALER_TFR';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_OTHER_DEALER_TFR = 'REQUEST_NEW_GROWER_OTHER_DEALER_TFR';
  public static readonly MESSAGE_REQUEST_NEW_GROWER_SEED_RESERVATION = 'REQUEST_NEW_GROWER_SEED_RESERVATION';
  public static readonly TOKEN_RETRY_COUNT = 'tokenretrycount';
  public static readonly URL_REFERRER = 'portal';
  public static readonly CONSOLE_MESSAGE = 'consoleMessage';

  // Product Line Constants
  public static readonly PRODUCT_LINE_LIST = [
    { Id: 'All', Value: 'All', Text: 'All', Image: '../assets/icon/svg/all.svg' },
    { Id: '4J1', Value: 'Soybeans', Text: 'Soybeans', Image: '' },
    { Id: '4A1', Value: 'Alfalfa', Text: 'Alfalfa', Image: '../assets/icon/svg/alfa.svg' },
    { Id: '4D1', Value: 'Corn', Text: 'Corn', Image: '../assets/icon/svg/corn.svg' },
    { Id: '4E1', Value: 'Cotton', Text: 'Cotton', Image: '../assets/icon/svg/cotton.svg' },
    { Id: '4I1', Value: 'ForageSorghum', Text: 'Forage Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4I2', Value: 'GrainSorghum', Text: 'Grain Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4L2', Value: 'SunflowerOil', Text: 'Sunflower Oil', Image: '../assets/icon/svg/sunflower.svg' },
    { Id: '4B1', Value: 'SpringCanola', Text: 'Spring Canola', Image: '../assets/icon/svg/canola.svg' },
    { Id: '4B2', Value: 'WinterCanola', Text: 'Winter Canola', Image: '../assets/icon/svg/canola.svg' },
    { Id: '244', Value: 'Inoculant', Text: 'Inoculant', Image: '../assets/icon/svg/inoculant.svg' }
  ];
  public static readonly PRODUCT_LINE_SOYBEAN = 'Soybeans';
  public static readonly PRODUCT_LINE_SOYBEAN_CODE = '4J1';
  public static readonly PRODUCT_LINE_ALL = 'All';
  // public static readonly PRODUCT_LINE_ALFALFA = "Alfalfa";
  public static readonly PRODUCT_LINE_CORN = 'Corn';
  // public static readonly PRODUCT_LINE_FORAGESORGHUM = "ForageSorghum";
  public static readonly PRODUCT_LINE_SUNFLOWEROIL = 'SunflowerOil';
  // public static readonly PRODUCT_LINE_SPRINGCANOLA = "SpringCanola";
  // public static readonly PRODUCT_LINE_WINTERCANOLA = "WinterCanola";
  // public static readonly PRODUCT_LINE_CANOLAWINTER = "CanolaWinter";
  public static readonly PRODUCT_LINE_INOCULANT = 'Inoculant';
  public static readonly PRODUCT_LINE_INOCULANT_CODE = 'PRODUCT_LINE_INOCULANT_CODE';
  public static readonly PRODUCT_LINE_INOCULANT_CODE2 = 'PRODUCT_LINE_INOCULANT_CODE2';
  public static readonly NUMBER_FORMAT: string = '1.2-2'; // {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
  public static readonly NUMBER_FORMAT_4DECIAL: string = '1.4-4'; // {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
  public static readonly NUMBER_SCALE: number = 3;
  public static readonly PAGE_SIZE = 50;
  public static readonly PAGE_SIZE_OPTIONS = [5, 10, 25, 50];
  public static readonly PAGE_SIZE_LARGE = 1000;
  public static readonly PAGE_SIZE_OPTIONS_LARGE = [1000, 2000, 5000];
  public static readonly DATE_MMDDYYYY = 'MM/dd/yyyy';
  public static readonly DATE_MMMYYYY = 'MMM yyyy';
  public static readonly GpAutoSave = 'GpAutoSave';
  public static readonly GrowerProgramProcessName = 'GpAutoSave';
  public static readonly GP_AUTO_SAVE_CONFIGURATION = 'GPAutosaveConfiguration';
  public static readonly CPP_PRODNAME_SEARCH_OPTIONS = 'cppProdNameSearchOptions';
  public static readonly SEED_PRODNAME_SEARCH_OPTIONS = 'seedProdNameSearchOptions';
  public static readonly VENDORNAME_SEARCH_OPTIONS = 'vendorNameSearchOptions';
  public static readonly CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS = 'cppPriceListProdNameSearchOptions';
  public static readonly UsNationalAccount = 9699061;
 
  public static readonly CPP_COI_STATUS_LIST = [
    { label: 'Shipment Requested', value: 'Shipment Requested' },
    { label: 'Shipment Created', value: 'Shipment Created' },
    { label: 'Shipment Cancelled', value: 'Shipment Cancelled' }
  ];
  public static readonly SEED_REPLANT_STATUS_LIST = [
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Approved', value: 'Approved' }
  ];
  public static readonly SEED_CROPLOSS_STATUS_LIST = [
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Approved', value: 'Approved' }
  ];
  public static readonly SEED_REPLANT_PRODUCT_LINE_LIST = [
    { Id: 'All', Value: 'All', Text: 'All', Image: '../assets/icon/svg/all.svg' },
    { Id: '4J1', Value: 'Soybeans', Text: 'Soybeans', Image: '' },
    { Id: '4A1', Value: 'Alfalfa', Text: 'Alfalfa', Image: '../assets/icon/svg/alfa.svg' },
    { Id: '4D1', Value: 'Corn', Text: 'Corn', Image: '../assets/icon/svg/corn.svg' },
    { Id: '4E1', Value: 'Cotton', Text: 'Cotton', Image: '../assets/icon/svg/cotton.svg' },
    { Id: '4I1', Value: 'ForageSorghum', Text: 'Forage Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4I2', Value: 'GrainSorghum', Text: 'Grain Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4L2', Value: 'SunflowerOil', Text: 'Sunflower Oil', Image: '../assets/icon/svg/sunflower.svg' },
    { Id: '4B1', Value: 'SpringCanola', Text: 'Spring Canola', Image: '../assets/icon/svg/canola.svg' },
    { Id: '4B2', Value: 'WinterCanola', Text: 'Winter Canola', Image: '../assets/icon/svg/canola.svg' }
  ];

  public static readonly CROP_LOSS_SEED_TYPE_LIST = [
    { Id: 'All', Value: 'All', Text: 'All', Image: '../assets/icon/svg/all.svg' },
    { Id: '4J1', Value: 'Soybeans', Text: 'Soybeans', Image: '' },
    { Id: '4A1', Value: 'Alfalfa', Text: 'Alfalfa', Image: '../assets/icon/svg/alfa.svg' },
    { Id: '4D1', Value: 'Corn', Text: 'Corn', Image: '../assets/icon/svg/corn.svg' },
    { Id: '4E1', Value: 'Cotton', Text: 'Cotton', Image: '../assets/icon/svg/cotton.svg' },
    { Id: '4I1', Value: 'ForageSorghum', Text: 'Forage Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4I2', Value: 'GrainSorghum', Text: 'Grain Sorghum', Image: '../assets/icon/svg/sorghum.svg' },
    { Id: '4L2', Value: 'SunflowerOil', Text: 'Sunflower Oil', Image: '../assets/icon/svg/sunflower.svg' },
    { Id: '4B1', Value: 'SpringCanola', Text: 'Spring Canola', Image: '../assets/icon/svg/canola.svg' },
    { Id: '4B2', Value: 'WinterCanola', Text: 'Winter Canola', Image: '../assets/icon/svg/canola.svg' }
  ];

  public static readonly SEED_REPLANT_SALESORDERNUMBER = 'seedReplantSalesOrderNumber';
  public static readonly EMAIL_PATTERN: any = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
  public static readonly INDIVIDUAL_EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  public static readonly SOT_STATUS_LIST = [
    { label: 'SUBMITTED', value: 'SUBMITTED' },
    { label: 'REJECTED', value: 'REJECTED' },
    { label: 'APPROVED', value: 'APPROVED' },
    { label: 'CANCELLED', value: 'CANCELLED' },
    { label: 'ERROR', value: 'ERROR' },
    { label: 'EDITING', value: 'EDITING' },
    { label: 'COMPLETED', value: 'COMPLETED' },
    { label: 'PENDING', value: 'PENDING' }
  ];

  public static readonly COT_STATUS_LIST = [
    { label: 'SUBMITTED', value: 'SUBMITTED' },
    { label: 'REJECTED', value: 'REJECTED' },
    { label: 'APPROVED', value: 'APPROVED' },
    { label: 'CANCELLED', value: 'CANCELLED' },
    { label: 'ERROR', value: 'ERROR' },
    { label: 'EDITING', value: 'EDITING' },
    { label: 'COMPLETED', value: 'COMPLETED' }
  ];

  public static readonly DELIVERY_INSTRUCTIONS_ERROR_MESSAGE = 'deliveryInstructionErrorMsg';
  public static readonly CONTENT_TYPE_FOR_EXTENSIONS = { xlsx: 'application/vnd.ms-excel', 'pdf': 'application/pdf', 'jpg': 'image/jpeg', 'jpeg': 'image/jpeg', 'png': 'image/png', 'doc': 'application/msword', 'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };

  public static readonly US_COMPANYCODE = "00555";

  public static USER_ACCESS = class {
    public static readonly BLANK = 'BLANK';
    public static readonly READ_ONLY = 'READ ONLY';
    public static readonly EDIT_FULL = 'EDIT-FULL';
  }

  public static FUNCTION_CODE = class {
    public static readonly GROWER_ORDERS_TAB = 'GOT';
    public static readonly DEALER_ORDERS_TAB = 'DOT';
    public static readonly ACCOUNTS_TAB = 'AT';
    public static readonly FULFILLMENT_TAB = 'FT';
    public static readonly FULFILLMENT_PRODUCT_AVAILABILITY_REPORT = 'FTSAR';
    public static readonly QUICK_ORDER_REPORT = 'QOR';
    public static readonly PRODUCT_AVAILABILITY_REPORT = 'PAR';
    public static readonly DEALER_AUDIT_REPORT = 'DAR';
    public static readonly GROWER_AUDIT_REPORT = 'GAR';
    public static readonly PARTNER_WEBSITE = 'PW';
    public static readonly EMULATION_DASHBOARD = 'ED';
    public static readonly TOTAL_ORDER_SUMMARY = 'TOS';
    public static readonly PREPAY = 'PP';
    public static readonly SHIPPABLE_PRODUCTS_REPORT = 'SPR';
    public static readonly DEALER_ORDER_ADD_PRODUCT = 'AP';
    public static readonly CROP_PROTECTION_PRODUCT_ORDER = 'CPPO';
    public static readonly MARKETING_PROGRAM_SUMMARY = 'CPPMP';
    public static readonly FORAGE_GENETICS_INTERNATIONAL_ORDER = 'FGIO';
    public static readonly FGI_ORDER_BRANCH_PLANT = 'FGOBP';
    public static readonly LICENSE_EVOLVE = 'LE';
    public static readonly CROP_PROTECTION_PRODUCT_ERROR_ORDER_MAINTENANCE = 'CPPE';
    public static readonly FORAGE_GENETICS_INTERNATIONAL_ERROR_ORDER_MAINTENANCE = 'FGIE';
    public static readonly FORAGE_GENETICS_INTERNATIONAL_ACCOUNT_REP = 'FGIAR';
    public static readonly CROP_PROTECTION_PRODUCT_PRICE_LIST = 'CPPPL';
    public static readonly SUBSTITUTION_ORDER_REPORT = 'SOR';
    public static readonly RETURN_REQUEST_INVENTORY_PROTECTION = 'RRIP';
    public static readonly RETURN_REQUEST_IP_APPROVAL = 'RRIPA';
    public static readonly ORDER_TO_INVOICE = 'OTI';
    public static readonly ORDER_TO_INVOICE_VIEW_PRICING = 'OTIVP';
    public static readonly QUOTE_CLOSE_PERMISSION = 'QCP';
    public static readonly QUOTE_ORDERS_PRICING = 'QOP';
    public static readonly QUOTE_APPROVE_OR_REJECT_PERMISSION = 'QARP';
    public static readonly CPP_RETURNS_PRODUCTS = 'CPPRP';
    public static readonly EARLY_ADVANTAGE_ORDER = 'EAOE';
    public static readonly COI_ORDER = 'CPPCOIO';
    public static readonly SEED_REPLANT = 'SRE';
    public static readonly SEED_REPLANT_APPROVAL = 'SRAE';
    public static readonly SEED_REPLANT_RETAILER_ENTRY_EFFECTIVE_DATE = 'SRREEDE';
    public static readonly SOT_STOCK_TRANSFERS = 'SOTST';
    public static readonly DELIVERY_INSTRUCTIONS = 'SFDIE';
    public static readonly CUSTOMER_INVENTORY_REPORT = 'CIR';
    public static readonly FULFILLMENT_SHIPPING_AVAILABILITY_REPORT = 'FSARE';
    public static readonly SEED_EARLY_ADVANTAGE_SWAP_PRODUCT = 'SEASW';
    public static readonly SEED_EARLY_ADVANTAGE_DECREASE_PRODUCT = 'SEADP';
    public static readonly SEED_EARLY_ADVANTAGE_MODIFY_PRODUCT = 'SEAMP';
    public static readonly SEED_EARLY_ADVANTAGE_ADD_PRODUCT = 'SEAAP';
    public static readonly GROWER_PROGRAMS = 'GP';
    public static readonly GROWER_PROGRAMS_SEED = 'GPSEED';
    public static readonly PRODUCT_LIST_CPCO_ELIGIBLE = 'PLCPCOE';
    public static readonly COMMAND_CENTER = 'CCL';
    public static readonly SRA_ORDERS = 'SROE';
    public static readonly SRA_APPROVERS = 'SROEA';
    public static readonly SEED_RESERVATION = 'SRS';
    public static readonly ORDER_INSIGHTS = 'OIPE';
    public static readonly CPP_USER_LIST = 'CPPUL';
    public static readonly CROP_ASSOCIATES = 'ACIEE';
    public static readonly CROP_ASSOCIATES_RECONCILIATION = 'ACIRE';
    public static readonly CROP_ASSOCIATES_INVENTORY = 'ACIIE';
    public static readonly PLOT_SEED = 'PLSEED';
    public static readonly PLOT_SEED_RELEASE = 'PLSEEDR';
    public static readonly AI_VIRTUAL_ASSISTANT = 'AIVA';
    public static readonly AI_VIRTUAL_ASSISTANT_SHIPMENT_TRACKING = 'AIVAST';
    public static readonly AI_VIRTUAL_ASSISTANT_CREATE_CPP_ORDER = 'AIVACPPO';
    public static readonly PROVING_GROUND_SEED_ORDER = 'PGSO';
  }

  public static RECON_REPORT_TYPE = class {
    public static readonly R1_NEW = 'R1_NEW';
    public static readonly R2_NEW = 'R2_NEW';
    public static readonly R3_NEW = 'R3_NEW';
    public static readonly R4_NEW = 'R4_NEW';
    public static readonly R5_NEW = 'R5_NEW';
    public static readonly R6_NEW = 'R6_NEW';
    public static readonly NEW1_1 = '1.1_NEW';
    public static readonly NEW1_4 = '1.4_NEW';
    public static readonly NEW1_5 = '1.5_NEW';
    public static readonly NEW1_6 = '1.6_NEW';
    public static readonly NEW2_1 = '2.1_NEW';
  }

  public static INSTRUMENTATION_KEYS = class {
    public static readonly DKEY = 'fc7abd38-28e7-4eeb-99a0-9f88bd920464';
    public static readonly SKEY = '2b2c90ea-2644-4994-9e78-d6ca1fda966b';
    public static readonly S2KEY = 'c9da87c4-c0dd-44f8-ad2d-88ba7ae87822';
    public static readonly PKEY = 'a8ba1393-ff38-4e1a-b0ab-741815fc02bc';
  }

  public static readonly RECON_REPORT_LIST = [
    { 'reportID': 'R1', 'reportName': 'Remittance', 'description': 'Review Final Balance Owing', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R1_NEW, 'reportKey': 'isR1_NewExist' },
    { 'reportID': 'R2', 'reportName': 'Recon invoices', 'description': 'Complete list of Invoices included in this Recon', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R2_NEW, 'reportKey': 'isR2_NewExist' },
    { 'reportID': 'R3', 'reportName': 'Payment On Account', 'description': 'Detailed list of Payments on Account and Balance Open', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R3_NEW, 'reportKey': 'isR3_NewExist' },
    { 'reportID': 'R4', 'reportName': 'Recon Adjustment', 'description': 'Invoices Generated from the Recon Process', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R4_NEW, 'reportKey': 'isR4_NewExist' },
    { 'reportID': 'R5', 'reportName': 'Program Credits', 'description': 'Program Related Invoices generated from the Recon', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R5_NEW, 'reportKey': 'isR5_NewExist' },
    { 'reportID': 'R6', 'reportName': 'Re-Termed Inventory', 'description': 'Carry Forward Invoices generated from the Recon', 'ReportType': MasterConstants.RECON_REPORT_TYPE.R6_NEW, 'reportKey': 'isR6_NewExist' },
    { 'reportID': '1.1', 'reportName': 'Recon Summary', 'description': 'By Manufacturer Summary of Sales and Rebill', 'ReportType': MasterConstants.RECON_REPORT_TYPE.NEW1_1, 'reportKey': 'is1_1NewExist' },
    { 'reportID': '1.4', 'reportName': 'Inventory – OTG', 'description': 'Product level detail for Rebill and Price Adjustments', 'ReportType': MasterConstants.RECON_REPORT_TYPE.NEW1_4, 'reportKey': 'is1_4NewExist' },
    { 'reportID': '1.5', 'reportName': 'Price Adjustment Details', 'description': 'List of Products Price Adjusted in the Recon', 'ReportType': MasterConstants.RECON_REPORT_TYPE.NEW1_5, 'reportKey': 'is1_5NewExist' },
    { 'reportID': '1.6', 'reportName': 'Rebill Details', 'description': 'List of Product Rebilled in the Recon', 'ReportType': MasterConstants.RECON_REPORT_TYPE.NEW1_6, 'reportKey': 'is1_6NewExist' },
    { 'reportID': '2.1', 'reportName': 'CPCO Summary', 'description': 'By Manufacturer CPCO Calculation', 'ReportType': MasterConstants.RECON_REPORT_TYPE.NEW2_1, 'reportKey': 'is2_1NewExist' }
  ];
}
